import React, { useRef, useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import {
  Box,
  Typography,
  MenuItem,
  Select,
  useTheme,
} from "@mui/material";
import { IoIosArrowDown } from "react-icons/io";
import ProcurementPopup from "./procurementPopUp";

const LongLeadItems = () => {
  const chartRef = useRef(null);
  const theme = useTheme();
  const [popupData, setPopupData] = useState(null);
  const [open, setOpen] = useState(false);

  // 👇 Click handler for pie slice
  const handlePointClick = function (event) {
    const point = event.point;
    setPopupData({
      name: point.name,
      value: point.y,
    });
    setOpen(true);
  };

  const options = {
    chart: {
      type: "pie",
      height: 180,
      backgroundColor: "transparent",
    },
    colors: ["#3E756D", "#E72B33"],
    tooltip: {
      enabled: true,
    },
    title: {
      text: ""
    },
    legend: {
      enabled: false,
    },
    plotOptions: {
      pie: {
        startAngle: 220,
        innerSize: "60%",
        cursor: 'pointer',
        dataLabels: [
          {
            enabled: false,
          },
          {
            enabled: true,
            distance: -15,
            format: "{point.y}",
            style: {
              fontSize: "11px",
              fontWeight: 600,
              color: "#fff",
            },
          },
        ],
        point: {
          events: {
            click: handlePointClick, 
          },
        },
      },
    },
    series: [
      {
        name: "Registrations",
        data: [
          { name: "On Time", y: 2 },
          { name: "Delayed", y: 2 },
        ],
      },
    ],
    credits: {
      enabled: false,
    },
  };

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        borderRadius: "7px",
        overflow: "hidden",
        backgroundColor: "white",
        border: "1px solid #2525252E",
        p: 2,
      }}
    >
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box>
          <Typography
            variant="h6"
            sx={{
              fontWeight: "500",
              fontSize: "18px",
              color: `${theme?.customSettings?.themeColor || "#000"}`,
              lineHeight: "100%",
              letterSpacing: "-0.4px",
            }}
          >
            Long Lead item - Status
          </Typography>
          <Typography
            variant="caption"
            sx={{
              fontWeight: "400",
              fontSize: "14px",
              color: "#182A4E80",
              lineHeight: "100%",
              letterSpacing: "-0.4px",
            }}
          >
          </Typography>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 0,
        }}
      >
        <Box sx={{ width: "50%", pl: 2 }}>
          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: "500",
              color: "#182A4E",
              fontSize: "16px",
              letterSpacing: "-0.4px",
              mb: 2,
              "&::before": {
                content: '""',
                display: "inline-block",
                width: "14px",
                height: "14px",
                backgroundColor: "#3E756D",
                borderRadius: "0%",
                marginRight: "8px",
              },
            }}
          >
            On Time :
            <span
              style={{
                fontWeight: "700",
                marginLeft: "8px",
              }}
            >
              2
            </span>
          </Typography>

          <Typography
            variant="body2"
            sx={{
              display: "flex",
              alignItems: "center",
              fontWeight: "500",
              color: "#182A4E",
              fontSize: "16px",
              letterSpacing: "-0.4px",
              mb: 2,
              "&::before": {
                content: '""',
                display: "inline-block",
                width: "14px",
                height: "14px",
                backgroundColor: "#CE412D",
                borderRadius: "0%",
                marginRight: "8px",
              },
            }}
          >
            Delayed :
            <span
              style={{
                fontWeight: "700",
                marginLeft: "8px",
              }}
            >
              2
            </span>
          </Typography>
        </Box>

        <Box sx={{ width: "50%" }}>
          <HighchartsReact
            highcharts={Highcharts}
            options={options}
            ref={chartRef}
          />
        </Box>
      </Box>

      {/* 👇 Render the popup */}
      {open && (
        <ProcurementPopup
          title={`Details: ${popupData?.name}`}
          value={popupData?.value}
          status={popupData?.name}
          onClose={() => setOpen(false)}
          onOpen={open}
        />
      )}
    </Box>
  );
};

export default LongLeadItems;
